import { LocaleType } from '../../../modules/i18n/config'
import { s_home } from '../../../modules/i18n/strings/auto/wording'
import { t } from '../../../modules/utils'
import { CDN_BUSINESS_URL_PREFIX } from '../constants/business.constants'

export const BUSINESS_REVIEW_LIST: (locale: LocaleType, isMobile: boolean) => Record<string, string>[] = (
  locale,
  isMobile
) => [
  {
    id: 'toss',
    logoUrl: `${CDN_BUSINESS_URL_PREFIX}/${isMobile ? 'mobile' : 'desktop'}/toss.png`,
    reviewText: t(s_home.business_review.toss.desktop, locale),
  },
  {
    id: 'celltrion',
    logoUrl: `${CDN_BUSINESS_URL_PREFIX}/${isMobile ? 'mobile' : 'desktop'}/celltrion.png`,
    reviewText: t(s_home.business_review.celltrion.desktop, locale),
  },
  {
    id: 'sk',
    logoUrl: `${CDN_BUSINESS_URL_PREFIX}/${isMobile ? 'mobile' : 'desktop'}/sk.png`,
    reviewText: t(s_home.business_review.sk.desktop, locale),
  },
  {
    id: 'yanolja',
    logoUrl: `${CDN_BUSINESS_URL_PREFIX}/${isMobile ? 'mobile' : 'desktop'}/yanolja.png`,
    reviewText: t(s_home.business_review.yanolja.desktop, locale),
  },
  {
    id: 'bcg',
    logoUrl: `${CDN_BUSINESS_URL_PREFIX}/${isMobile ? 'mobile' : 'desktop'}/bcg.png`,
    reviewText: t(s_home.business_review.bcg.desktop, locale),
  },
  {
    id: 'devsisters',
    logoUrl: `${CDN_BUSINESS_URL_PREFIX}/${isMobile ? 'mobile' : 'desktop'}/devsisters.png`,
    reviewText: t(s_home.business_review.devsisters.desktop, locale),
  },
]
